import React from 'react';

const NewTeam = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='16.6897' y='4' width='1.10346' height='5.51727' fill='black' />
      <rect
        x='14.4827'
        y='7.31036'
        width='1.10345'
        height='5.51727'
        transform='rotate(-90 14.4827 7.31036)'
        fill='black'
      />
      <path
        d='M16.138 19.4483H15.0345V18.3449C15.0341 17.906 14.8595 17.4853 14.5492 17.175C14.2389 16.8647 13.8182 16.6902 13.3794 16.6897H11.1725C10.7336 16.6902 10.3129 16.8647 10.0026 17.175C9.69229 17.4853 9.51775 17.906 9.51727 18.3449V19.4483H8.41382V18.3449C8.41468 17.6135 8.7056 16.9123 9.22276 16.3952C9.73991 15.878 10.4411 15.5871 11.1725 15.5862H13.3794C14.1107 15.5871 14.8119 15.878 15.3291 16.3952C15.8462 16.9123 16.1371 17.6135 16.138 18.3449V19.4483Z'
        fill='black'
      />
      <path
        d='M12.276 10.069C12.6033 10.069 12.9233 10.166 13.1955 10.3479C13.4677 10.5298 13.6799 10.7883 13.8052 11.0907C13.9304 11.3932 13.9632 11.726 13.8993 12.0471C13.8355 12.3681 13.6778 12.6631 13.4464 12.8945C13.2149 13.126 12.92 13.2837 12.5989 13.3475C12.2778 13.4114 11.945 13.3786 11.6426 13.2533C11.3401 13.1281 11.0816 12.9159 10.8997 12.6437C10.7179 12.3715 10.6208 12.0515 10.6208 11.7242C10.6208 11.2852 10.7952 10.8642 11.1056 10.5538C11.416 10.2434 11.837 10.069 12.276 10.069V10.069ZM12.276 8.96552C11.7304 8.96552 11.197 9.12731 10.7434 9.43043C10.2897 9.73355 9.93612 10.1644 9.72732 10.6685C9.51853 11.1725 9.4639 11.7272 9.57034 12.2623C9.67678 12.7975 9.93952 13.289 10.3253 13.6748C10.7111 14.0606 11.2027 14.3233 11.7378 14.4298C12.2729 14.5362 12.8276 14.4816 13.3317 14.2728C13.8357 14.064 14.2666 13.7104 14.5697 13.2568C14.8728 12.8031 15.0346 12.2698 15.0346 11.7242C15.0346 10.9925 14.744 10.2908 14.2266 9.7735C13.7093 9.25616 13.0076 8.96552 12.276 8.96552Z'
        fill='black'
      />
      <path
        d='M7.86209 10.6207H6.75864C6.02726 10.6216 5.3261 10.9125 4.80894 11.4297C4.29178 11.9468 4.00086 12.648 4 13.3794V15.5863H5.10345V13.3794C5.10394 12.9405 5.27848 12.5198 5.58878 12.2095C5.89908 11.8992 6.3198 11.7247 6.75864 11.7242H7.86209V10.6207Z'
        fill='black'
      />
      <path
        d='M7.86215 5.10345C8.18952 5.10345 8.50953 5.20053 8.78172 5.3824C9.05392 5.56428 9.26606 5.82278 9.39134 6.12523C9.51662 6.42767 9.5494 6.76047 9.48553 7.08155C9.42167 7.40262 9.26402 7.69755 9.03254 7.92903C8.80106 8.16051 8.50614 8.31815 8.18506 8.38202C7.86399 8.44588 7.53119 8.4131 7.22874 8.28783C6.9263 8.16255 6.66779 7.9504 6.48592 7.67821C6.30405 7.40601 6.20697 7.086 6.20697 6.75864C6.20697 6.31966 6.38136 5.89865 6.69176 5.58825C7.00217 5.27784 7.42317 5.10345 7.86215 5.10345V5.10345ZM7.86215 4C7.31655 4 6.78319 4.16179 6.32954 4.46491C5.87588 4.76804 5.5223 5.19888 5.31351 5.70295C5.10471 6.20703 5.05008 6.7617 5.15652 7.29682C5.26297 7.83194 5.5257 8.32349 5.9115 8.70929C6.2973 9.09509 6.78885 9.35782 7.32397 9.46427C7.85909 9.57071 8.41376 9.51608 8.91784 9.30729C9.42191 9.09849 9.85275 8.74491 10.1559 8.29125C10.459 7.8376 10.6208 7.30424 10.6208 6.75864C10.6208 6.027 10.3301 5.32533 9.8128 4.80799C9.29546 4.29064 8.59379 4 7.86215 4V4Z'
        fill='black'
      />
    </svg>
  );
};

export default NewTeam;
